import Util from "../Util.js";
export default {
  id: 'molten.history.parentRelationship.NotEquals.ComparatorFilterConverter',
  type: 'parentRelationship.NotEquals',
  convert: (value, attribute) => {
    if (value?.value1 == null || value.value1.length === 0) {
      return null;
    }
    const field = Util.getHistoryFieldFromField(attribute.blueprint.field);
    if (Array.isArray(value.value1)) {
      if (value.value1.length === 1) {
        return Util.createSingleComparatorFilter(value.value1[0], '<>', field);
      }
      return ['or', value.value1.map(v => Util.createSingleComparatorFilter(v, '<>', field))];
    }
    return Util.createSingleComparatorFilter(value.value1, '<>', field);
  }
};